<template>
    <div class="d-flex flex-column align-items-center justify-content-center gap-3 p-3">
        <p class="text-bold text-capitalize">{{ $t('questions') }}</p>
        <div class="question-palette d-flex justify-content-center align-items-center" :class="{ active: question.submissions.answer || question.submissions.files != null }" @click="switchQuestion()">
            <div class="question-palette-value">{{ currentQuestion }} <span>/{{ questions.length }}</span></div>
        </div>
        <button class="ito-btn ito-btn-primary" @click="nextQuestion()" :disabled="isLastQuestion">{{ $t('next') }}</button>
        <modal-dialog ref="popup" backdrop="static">
            <div class="d-flex flex-column align-items-center gap-3 p-3">
                <a href="javascript:void(0)" class="close-modal" @click="closeModal"><i class="ito-icon-close modal-close"></i></a>
                <h2>{{ $t('questions') }}</h2>
                <div class="question-list justify-content-center row row-cols-5 g-3">
                    <div class="col" v-for="(quest, index) in questions" :key="quest.id">
                        <button class="question 111 " :class="{ active: quest.id === mutableQuestion.id, filled: quest.completed == 1 }" @click="selectQuestion(quest)"> {{ index + 1 }}</button>
                    </div>
                </div>
                <div class="d-flex justify-content-center gap-3">
                    <button class="ito-btn ito-btn-primary" @click="_confirm">{{ $t('select') }}</button>
                </div>
            </div>
        </modal-dialog>
    </div>
</template>
<script>
import ModalDialog from '../../modal/ModalDialog.vue'
export default {
    name: "QuestionPallette",
    props: ['question', 'questions'],
    components: { ModalDialog },
    data() {
        return {
            mutableQuestion: JSON.parse(JSON.stringify(this.question)),
        };
    },
    computed: {
        currentQuestion() {
            return this.questions.findIndex((q) => q.id === this.question.id) + 1;
        },
        isLastQuestion() {
            const currentIndex = this.questions.findIndex(q => q.id === this.mutableQuestion.id);
            return currentIndex === this.questions.length - 1;
        }
    },
    methods: {
        switchQuestion() {
            this.$refs.popup.open();
        },
        _confirm() {
            this.$emit('changeQuestion', this.mutableQuestion);
            this.$refs.popup.close();
        },
        closeModal() {
            this.mutableQuestion = this.question;
            this.$refs.popup.close();
        },
        selectQuestion(question) {
            this.mutableQuestion = question;
        },
        nextQuestion() {
            const currentIndex = this.questions.findIndex(q => q.id === this.mutableQuestion.id);
            if (currentIndex !== -1 && currentIndex < this.questions.length - 1) {
                this.mutableQuestion = this.questions[currentIndex + 1];
                this.$emit('changeQuestion', this.mutableQuestion);
            }
        }
    }
}
</script>
<style scoped>
.question-palette {
    width: 80px;
    height: 80px;
    border: 2px solid #EAEAEA;
    background-color: #FFFFFF;
    border-radius: 80%;
    color: #000000;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.3s;
}

.question-palette:hover {
    transform: scale(1.1);
}


.question-palette.active {
    border-color: #0EA5E9 !important;
    background-color: #DBEAFE !important;
}

.question-palette.correct {
    border-color: #58CC02 !important;
    background-color: #E8FFD8 !important;
}

.question-palette.in-correct {
    border-color: #FF3D54 !important;
    background-color: #FFD6DB !important;
}

.question-palette .question-palette-value {
    font-size: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.question-palette .question-palette-value span {
    font-size: 20px;
}

.close-modal {
    position: absolute;
    right: 9px;
    top: 8px;
}

h2 {
    margin-top: 0;
    font-size: 20px;
    font-weight: bold;
}

ul {
    list-style: none;
    padding: 0;
    margin: 0;
    gap: 14px;
}

.question-list {
    width: 416px;
}

.question {
    width: 54px;
    height: 54px;
    border: none;
    background-color: #EAEAEA;
    border-radius: 50%;
    color: #000000;
    font-family: Nunito;
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    position: relative;
}

.question.filled {
    background-color: #0EA5E9;
    color: #ffffff;
}

.question::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 2px solid transparent;
    border-radius: 50%;
    transition: all .2s ease-in-out;
}

.question.active::after,
.question:hover::after {
    border-color: #0EA5E9;
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
}
</style>